import React from "react";
import RelevantLinkBlock from "../fragments/RelevantLinkBlock";

export default function Article4() {

    let relevantUrls = ["/vehicleOrder/catalog?vehicleCategory=CHN_ORDER", "/vehicleOrder/pricing", "/loan"];

    return (
        <div className="site-section">
            <div className="container">
                <div className="row">
                    <div className="col-md-7 blog-content ml-auto order-lg-1">
                        <h2>Рекорд по продажам BYD Song Plus</h2>

                        <p>20 июля китайская автомобильная компания BYD Auto объявила о том, что общее количество проданных авто модели BYD Song Plus превзошло один миллион экземпляров. Эта модель, достигнув подобного показателя, стала лучшим электрическим внедорожником в Китае.</p>
                        <p>Производят этот электромобиль с начала осени 2020 года; изначально он был оснащён двигателем внутреннего сгорания, однако с 2021 года компания сосредоточилась на разработке автомобилей с новейшими источниками энергии. Сюда входят как гибридные, так и абсолютно электрические варианты, при этом в течение прошлого года было реализовано 427 071 экземпляров, а в 2024 г. уже произведено свыше 800 тыс. Высокий уровень реализации обусловлен методом DM пятого поколения, которая сочетает в себе мощность с экономичным потреблением топлива и электроэнергии.</p>
                        <p>Модель BYD Song Plus также популярна в Беларуси, где активно используется в качестве такси.</p>
                        <p>Электрокроссоверы BYD доступны в 88 странах и больше чем в 400 населённых пунктах по всему миру.</p>

                        <img src="/pictures/blog/IMG_6083.JPG" className="img-fluid" alt="Responsive image"/>
                    </div>

                    <div className="col-lg-4 order-lg-2">
                        <RelevantLinkBlock relevantUrls={relevantUrls}/>
                    </div>

                </div>
            </div>
        </div>

    );

}
